import axiosInstance from "../Interceptor"

export const getReqCategoriesApi = (payload) => {

	const prodUrl = process.env.REACT_APP_BASE_URL_TWO
	return (
		axiosInstance
			.get(prodUrl + `inventory/api/v1/${payload}/`)
			 
			.then(function (response) {
			
				return response
			})
			.catch((error) => {
			
				return error
			})
	)
}
